import { getPrivateApi, getPublicApi } from "../lib/axiosConfig";
import { User, UserLogin } from "../types/user.types";

const api = getPublicApi();
const privateApi = getPrivateApi();

const endpoint = "/user"

export const userLogin = async (login: string, password: string): Promise<UserLogin> => {
  
  try {
    const { data: user } = await api.post(`${endpoint}/login`, {
      login,
      password,
    });

    return user;
  } catch (error) {
    console.log("login error", error)
    throw new Error("Credenciais inválidas");
  }
};

export const userAuth = async ():Promise<User> => {
  
  try {
    const { data: user } = await privateApi.get<User>(`${endpoint}`);

    return user;
  } catch (error) {
    console.log("Falha ao autenticar usuário", error)
    throw new Error("Falha ao autenticar usuário");
  }
};

